import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  .MuiFormControl-root {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 100%;
    /* align-items: flex-end; */
  }

  .MuiFormControlLabel-root {
    margin: 0px;
    color: #757575;

    input[type='checkbox'] {
      cursor: pointer;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      outline: 0;
      background: #ffffff;
      width: 20px;
      height: 20px;
      margin-right: 8px;
      border: 1.67275px solid #c2c2c2;
      border-radius: 4.181px;
    }

    input[type='checkbox']:checked {
      background: #0384ac;
      border: none;
    }

    input[type='checkbox']:after {
      content: '';
      position: relative;
      left: 38%;
      top: 15%;
      width: 25%;
      height: 55%;
      border: solid #fff;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
      display: none;
    }

    input[type='checkbox']:checked:after {
      display: block;
    }
  }
`;
